import Vue from 'vue';
import { mapGetters } from 'vuex';
import { removeTrailingSlash } from '@/core/utils/utils';

const VideoProgressTrackingMixin = Vue.extend({
  computed: {
    ...mapGetters({
      student: 'user/student',
    }),
    studioURL() {
      return 'default';
    },
    mediaId() {
      return -1;
    },
    mediaProgress() {
      return -1;
    },
    mediaMinStart() {
      return 0;
    },
    seekStartTimestamp() {
      return Math.max(
        Math.max(this.currentTime, this.mediaProgress),
        this.mediaMinStart
      );
    },
    preventForwardSeeking() {
      return false;
    },
  },
  data() {
    return {
      vimeoPlayer: null,
      videoPlayer: null,
      currentTime: 0,
      totalLength: 0,
      seekStart: null,
      storedMediaId: null,
    };
  },
  methods: {
    trackVideoProgress() {
      //console.log('trackVideoProgress', this.studioURL, this.storedMediaId, this.currentTime, this.totalLength)
      if (this.currentTime === 0) return;
      if (this.currentTime === null) return;

      let progressPercent = 0;
      if (this.totalLength > 0)
        progressPercent = Math.ceil(
          (this.currentTime / this.totalLength) * 100
        );

      // const progressEncoded = btoa(''+this.currentTime)
      // const progressPercentEncoded = btoa(''+progressPercent)
      const progressEncoded = '' + this.currentTime;
      const progressPercentEncoded = '' + progressPercent;

      const url = `${removeTrailingSlash(
        process.env.VUE_APP_API_BASE_URL
      )}/api/studios/${this.studioURL}/progress/${
        this.storedMediaId
      }/record?student_id=${
        this.student.id
      }&progress=${progressEncoded}&progress_percent=${progressPercentEncoded}`;
      navigator.sendBeacon(url, null);
    },
    setCurrentTime(currentTime) {
      this.currentTime = currentTime;
    },
    visibilityDependentTrackVideoProgress() {
      if (document.visibilityState === 'hidden') {
        this.trackVideoProgress();
        if (this.vimeoPlayer) {
          // @ts-ignore
          this.vimeoPlayer.pause();
        }
        if (this.videoPlayer) {
          // @ts-ignore
          this.videoPlayer.pause();
        }
      }
    },
    async onVimeoPlayerReady(player) {
      this.vimeoPlayer = player;
    },
    async onVimeoPlayerLoaded({ data, player }) {
      this.totalLength = await player.getDuration();
      if (this.mediaProgress && this.mediaProgress < this.totalLength) {
        //console.log('Set vimeo player progess to ', this.mediaProgress)
        await player.setCurrentTime(this.mediaProgress);
        this.currentTime = this.mediaProgress;
      }
    },
    async onVimeoPlayerDurationChanged({ data, player }) {},
    async onVimeoPlayerSeeking({ data, player }) {
      //console.log('onVimeoPlayerSeeking', this.seekStart)
      if (this.seekStart === null) {
        this.seekStart = this.seekStartTimestamp;
      }
    },
    async onVimeoPlayerSeeked({ data, player }) {
      //console.log('onVimeoPlayerSeeked', this.currentTime, this.seekStart)
      // @ts-ignore
      if (this.seekStart !== null && data.seconds > this.seekStart) {
        //console.log('resetting video to seekStart', this.seekStart)
        // @ts-ignore
        if (this.preventForwardSeeking) {
          await this.vimeoPlayer.setCurrentTime(this.seekStart);
        }
      }
      // @ts-ignore
      this.seekStart = null;
    },
    async onVimeoPlayerTimeupdate({ data, player }) {
      //console.log('onVimeoPlayerTimeupdate', data.seconds, this.currentTime)
      if (
        data.seconds - 1 < this.currentTime &&
        data.seconds > this.currentTime
      ) {
        //console.log('Updating currentTime to ', data.seconds)
        this.currentTime = data.seconds;
      }
    },
    async onVimeoPlayerPaused({ data, player }) {
      this.trackVideoProgress();
    },
    async onVimeoPlayerEnded({ data, player }) {
      this.currentTime = this.totalLength;
      this.trackVideoProgress();
    },
    async onVideoPlayerReady(player) {
      this.videoPlayer = player;
      this.totalLength = player.duration;
    },
    async onVideoPlayerLoaded(event) {
      //console.log('onVideoPlayerLoaded', event)
    },
    async onVideoPlayerDurationChanged(event) {
      //console.log('onVideoPlayerDurationChanged', event)
      this.videoPlayer = event.target;
      if (this.seekStartTimestamp) {
        //console.log('Set video player progess to ', this.seekStartTimestamp)
        // @ts-ignore
        this.videoPlayer.currentTime = this.seekStartTimestamp;
        // @ts-ignore
        this.currentTime = this.seekStartTimestamp;
        // @ts-ignore
        await this.videoPlayer.pause();
      }
    },
    async onVideoPlayerSeeking(event) {
      if (this.seekStart === null) {
        this.seekStart = this.seekStartTimestamp;
        //console.log('onVideoPlayerSeeking', this.seekStart)
      }
    },
    async onVideoPlayerSeeked(event) {
      //console.log('onVideoPlayerSeeked', this.currentTime, this.seekStart)
      if (
        this.seekStart !== null &&
        this.videoPlayer.currentTime > this.seekStart
      ) {
        // @ts-ignore
        //console.log('resetting video to seekStart', this.seekStart)
        if (this.preventForwardSeeking) {
          this.videoPlayer.currentTime = this.seekStart;
        }
      }
      this.seekStart = null;
    },
    async onVideoPlayerTimeupdate(event) {
      //console.log('onVideoPlayerTimeupdate', this.videoPlayer.currentTime, this.currentTime, this.seekStart)
      if (
        this.videoPlayer.currentTime - 1 < this.currentTime &&
        this.videoPlayer.currentTime > this.currentTime
      ) {
        //if (this.seekStart === null) {
        // @ts-ignore
        this.currentTime = this.videoPlayer.currentTime;
        //console.log('set CurrentTime to ', this.currentTime)
      }
    },
    async onVideoPlayerPaused(event) {
      this.trackVideoProgress();
    },
    async onVideoPlayerEnded(event) {
      this.currentTime = this.totalLength;
      this.trackVideoProgress();
    },
  },
  created() {
    window.addEventListener('beforeunload', this.trackVideoProgress);
    document.addEventListener(
      'visibilitychange',
      this.visibilityDependentTrackVideoProgress
    );
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.trackVideoProgress);
    document.removeEventListener(
      'visibilitychange',
      this.visibilityDependentTrackVideoProgress
    );
    this.trackVideoProgress();
  },
  watch: {
    mediaId: {
      handler: function (newVal, oldVal) {
        if (this.storedMediaId === null) {
          this.storedMediaId = newVal;
        }
      },
      immediate: true,
    },
  },
});

export default VideoProgressTrackingMixin;
